<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">数据走势</span>
      </div>
    </div>
    <div class="filter-box">
      <span class="subtitle">查询时间：</span>
      <DatePicker
        type="date"
        v-model="start"
        placeholder="开始时间"
        style="width: 130px; margin-left: 10px"
      ></DatePicker>
      <span style="margin: 0 5px">至</span>
      <DatePicker
        type="date"
        v-model="end"
        placeholder="结束时间"
        style="width: 130px"
      ></DatePicker>
      <Button type="primary" style="margin-left: 10px" @click="getData"
        >查询</Button
      >
      <Button style="margin-left: 5px" @click="reset">清空</Button>
    </div>
    <div style="position: relative">
      <div class="charts">
        <div style="width: 33.33%; height: 250px" ref="color"></div>
        <div style="width: 33.33%; height: 250px" ref="duplex"></div>
        <div style="width: 33.33%; height: 250px" ref="job_type"></div>
      </div>
      <Spin fix v-if="tableLoad">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import echarts from "echarts";
import { monDiff,verifyDate} from "@/libs/util";
export default {
  data() {
    this.color = {
      0: { text: "黑白" },
      1: { text: "彩色" },
    };
    this.duplex = {
      0: { text: "单面" },
      1: { text: "双面" },
    };
    this.job_type = {
      1: { text: "打印" },
      2: { text: "复印" },
      3: { text: "扫描" },
      4: { text: "传真" },
      5: { text: "相片冲印" },
      6: { text: "身份证复印" },
    };
    return {
      tableLoad: true,
      date: [],
      start: "",
      end: "",
      startOptions: {
        disabledDate: (date) => {
          let data = this.end == "" ? Date.now() : this.end;
          return date >= data;
        },
      }, //开始日期设置
      endOptions: {
        // 指定终止日期
        disabledDate: (date) => {
          let data = this.start == "" ? "" : this.start;
          return date < data;
        },
      }, //结束日期设置
    };
  },
  mounted() {
    let now = new Date();
    let last = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
    this.start = this.$moment(now, "YYYY-MM") + "-01";
    this.end = this.$moment(now, "YYYY-MM") + `-${last}`;

    this.getData();
  },
  methods: {
    getData() {
      let start = this.$moment(this.start, "YYYY-MM-DD"),
        end = this.$moment(this.end, "YYYY-MM-DD");
      if (verifyDate(start, end)) {
        //如果时间跨度超过一年就提示
        this.$Message.error("开始时间不能大于结束时间");
        return;
      }
      if (monDiff(start, end) > 3) {
        //如果时间跨度超过一年就提示
        this.$Message.error("筛选的时间跨度不能超过3个月");
        return;
      }
      this.tableLoad = true;
      this.GetJobPie({ start, end }).then((res) => {
        this.initChart(res);
      });
    },
    formatOption(data) {
      return {
        title: {
          text: data.title,
          x: "center",
        },
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: data.xData,
        },
        series: [
          {
            name: "操作占比",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: data.seriesData,
            // [
            //   {value:335, name:'直接访问'},
            //   {value:310, name:'邮件营销'},
            //   {value:234, name:'联盟广告'},
            //   {value:135, name:'视频广告'},
            //   {value:1548, name:'搜索引擎'}
            // ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
    initChart(data) {
      let color = { title: "颜色占比", xData: [], seriesData: [] };
      data.color.map((item) => {
        color.xData.push(this.color[item.color].text);
        color.seriesData.push({
          value: item.total,
          name: this.color[item.color].text,
        });
      });
      let colorOption = this.formatOption(color);
      this.colorChart = echarts.init(this.$refs.color);
      this.colorChart.setOption(colorOption);

      // duplex
      // job_type

      let duplex = { title: "单双面占比", xData: [], seriesData: [] };
      data.duplex.map((item) => {
        duplex.xData.push(this.duplex[item.duplex].text);
        duplex.seriesData.push({
          value: item.total,
          name: this.duplex[item.duplex].text,
        });
      });
      let duplexOption = this.formatOption(duplex);
      this.duplexChart = echarts.init(this.$refs.duplex);
      this.duplexChart.setOption(duplexOption);

      let job_type = { title: "作业类型占比", xData: [], seriesData: [] };
      data.job_type.map((item) => {
        job_type.xData.push(this.job_type[item.job_type].text);
        job_type.seriesData.push({
          value: item.total,
          name: this.job_type[item.job_type].text,
        });
      });
      let job_typeOption = this.formatOption(job_type);
      this.job_typeChart = echarts.init(this.$refs.job_type);
      this.job_typeChart.setOption(job_typeOption);
      this.tableLoad = false;
    },
    reset() {
      let now = new Date();
      let last = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
      this.start = this.$moment(now, "YYYY-MM") + "-01";
      this.end = this.$moment(now, "YYYY-MM") + `-${last}`;
      this.getData();
    },
    ...mapActions(["GetJobPie"]),
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
